// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  tabId: __t.u64().primaryKey().name("tab_id"),
  workspaceId: __t.u64().name("workspace_id"),
  userIdentity: __t.identity().name("user_identity"),
  kind: __t.string(),
  payloadJson: __t.string().name("payload_json"),
  openedAt: __t.i64().name("opened_at"),
});
